import {
  Component,
  Input,
  QueryList,
  ViewChildren,
  OnDestroy,
} from '@angular/core';
import { NavigationLink } from '@cigna/chcp/shared/util';
import { HoverDropdownDirective } from '@cigna/chcp/shared/ui';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';
import { Subject, skip, filter, takeUntil } from 'rxjs';
@Component({
  selector: 'cigna-evernorth-header-util',
  templateUrl: './evernorth-header-util.component.html',
  styleUrls: ['./evernorth-header-util.component.scss'],
})
export class EvernorthHeaderUtilComponent implements OnDestroy {
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() userid = '';
  @Input() profileLinks: NavigationLink[] = [];
  @Input() isImpersonator = false;
  @Input() isMessageCenterEnabled = false;

  private _onDestroy$ = new Subject<void>();

  @ViewChildren(HoverDropdownDirective)
  dropdownList: QueryList<HoverDropdownDirective>;

  constructor(private routerFacade: RouterFacade) {
    this.routerFacade.url$
      .pipe(
        skip(1),
        filter(() => this.dropdownList && this.dropdownList.length > 0),
        takeUntil(this._onDestroy$),
      )
      .subscribe(() =>
        this.dropdownList.forEach((d) => d.isOpen && d.onFocusOut()),
      );
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
